import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

export const StyledTitle = styled.h2`
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 1px;
  color: ${props => (props.light ? "#fff" : "#000")};
  padding-bottom: 12px;
  margin-bottom: 12px;
  text-align: ${props => (props.center ? "center" : "left")};
  position: relative;
  & span {
    color: ${props => (props.light ? "#fff" : "#000")};
    font-family: "Made Bold", sans-serif;
  }
  & em {
    color: #c39779;
    font-style: normal;
  }
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 70px;
    height: 2px;
    background-color: #c39779;
  }
  @media (min-width: 768px) {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 1px;
    padding-bottom: 19px;
    margin-bottom: 19px;
    &::after {
      width: 100px;
    }
  }
`

const Title = props => {
  const { children } = props
  return <StyledTitle {...props}>{children}</StyledTitle>
}

export default Title

Title.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  center: PropTypes.bool,
  light: PropTypes.bool,
}

Title.defaultProps = {
  center: false,
  light: false,
}
